module.exports = __webpack_public_path__ + "img/1F1EA-1F1FA.507396a3.svg";